import SpinnerController from "../../../SpinnerController";
import ScrollUtils from "../../../util/ScrollUtils";
import $ from "jquery";
import makeRpcCall from "../../../util/jquery_rpc";
import messageResource from "../../../messageResource";
import {escapeHtmlSymbols} from "../../../atUtils";
import {KEY_CODE_ESC, KEY_CODE_ENTER, KEY_CODE_DEL, KEY_CODE_SPACE, KEY_CODE_TAB, KEY_CODE_UP, KEY_CODE_DOWN} from  "../../../keyCodes";
import {cancelBubble} from "../../../atBrowserUtils";
import _ from "underscore";
import KEY_HANDLERS from "../../../keyHandlers/index";


export default class PermissionsTemplatesMenu
{
    init({
        menuId,
        templatesData,
        onCreateTemplateCallback,
        onEditTemplateCallback,
        onSelectTemplateCallback,
        onErrorCallback = () => {},
        onDeleteCallback,
        canShowMenu,
        onClickDialogContent = () => {},
    })
    {
        this.onCreateTemplateCallback = onCreateTemplateCallback;
        this.onEditTemplateCallback = onEditTemplateCallback;
        this.onSelectTemplateCallback = onSelectTemplateCallback;
        this.onErrorCallback = onErrorCallback;
        this.onDeleteCallback = onDeleteCallback;
        this.onClickDialogContent = onClickDialogContent
        this.canShowMenu = canShowMenu;

        this.menuId = menuId;
        this.actualTemplatesData = templatesData;

        this.spinnerController = new SpinnerController();

        this.isShow = false;
        this.isDisabledControls = false;

        return this;
    }

    updateTemplatesData(newData)
    {
        this.actualTemplatesData = newData;
    }

    _deleteTemplateAction(row, templateId)
    {
        var context = this;
        this._spinInRow(row);
        this.isDisabledControls = true;
        this.deletingRpc = makeRpcCall(
                "PermissionsTemplatesService.deleteTemplate",
                [templateId],
                function(response)
                {
                    context._stopSpin(row);
                    context.isDisabledControls = false;

                    context.updateTemplatesData(response);
                    context._renderContent(context.getMenuElement(), response);
                    if (context.onDeleteCallback)
                    {
                        context.onDeleteCallback(response);
                    }
                },
                function(jqXHR, textStatus, errorThrown)
                {
                    context._stopSpin(row);
                    context.isDisabledControls = false;

                    if (errorThrown.exception == "com.actimind.actitime.services.NoRightsToManageAccountSettings")
                    {
                        alert(messageResource.getMessage("userlist.js.error_cant_edit_user_account"));
                        context.hide();
                        context.onErrorCallback();
                        document.location.reload();
                        return true;
                    }
                }
        );
    }

    _spinInRow(row)
    {
        row.toggleClass("deletingState", true);
        this.spinnerController.spinInElement(row.find("#spinnerContainer"));
    }

    _stopSpin(row)
    {
        row.toggleClass("deletingState", false);
        this.spinnerController.stop();
    }

    /**
     * Render inner content for menu
     * @param container menu container
     * @param templatesData array of templates
     * @private
     */
    _renderContent(container, templatesData)
    {
        container.empty();

        var context = this;
        container.append("<div class='templatesHeader'>" +
                         "<span>" + messageResource.getMessage("userlist.userdata.permissions_templates.js.menu.header") + "</span></div>");

        var templatesListWrapper = $("<div class='templatesListWrapper'></div>");
        var templatesListContainer = $("<table class='templatesListContainer'></table>");
        templatesListWrapper.append(templatesListContainer);
        _.each(
                templatesData,
                function(template, index)
                {
                    var newRow = context._renderRowContent(template, template.id == window.DEFAULT_PERMISSIONS_TEMPLATE_ID);
                    newRow.on(
                            "hover",
                            function()
                            {
                                context._setActiveRow(newRow);
                            }
                    );

                    if (index == 0)
                    {
                        context._setActiveRow(newRow);
                    }

                    templatesListContainer.append(newRow);
                }
        );
        this.templatesListScroll = ScrollUtils.addVerticalScroll(templatesListWrapper, {isFaded: false});
        container.append(templatesListWrapper);

        var footer = $("<div class='templatesFooter'></div>");
        var createNewTemplateButton = $("<a href='javascript:void(0);' class='createNew'>" + messageResource.getMessage("userlist.userdata.permissions_templates.js.menu.create_new") + "</a>");
        footer.append(createNewTemplateButton);
        container.append(footer);
        createNewTemplateButton.on(
                "click",
                function(event)
                {
                    context.onCreateTemplateCallback();
                }
        );
    }

    /**
     * Render content for one row
     * @param templateData of one row
     * @param isDefaultRow if row of default template
     * @returns {*|jQuery|HTMLElement} element (row) - row
     * @private
     */
    _renderRowContent(templateData, isDefaultRow)
    {
        var context = this;
        var canBeDeleted = !isDefaultRow;
        var row = $("<tr class='templateRow'></tr>");
        var rowInnerContent = $("<tr></tr>");

        this._appendInnerRowContent(rowInnerContent, templateData, isDefaultRow);

        var delBtn = $("<td class='delBtn'><div></div></td>");
        rowInnerContent.append(delBtn);
        if (canBeDeleted)
        {
            delBtn.on(
                    "click",
                    function()
                    {
                        context._switchRowToDeleteConfirmState(row, true);
                    }
            );

            var deleteConfirmation = $("<td class='deleteConfirmation'></td>");

            var confirmationContent = $("<table></table>");
            deleteConfirmation.append(confirmationContent);

            var confirmationRow = $("<tr></tr>");
            confirmationContent.append(confirmationRow);

            confirmationRow.append("<td class='question'><div>" + messageResource.getMessage("userlist.userdata.permissions_templates.js.menu.delete_confirmation") + "</div></td>");
            var confirmBtn = $("<td class='confirmBtn'><button>" + messageResource.getMessage("userlist.userdata.permissions_templates.js.menu.delete_confirm") + "</button></td>");
            confirmBtn.on(
                    "click",
                    function()
                    {
                        if (context.isDisabledControls)
                        {
                            return;
                        }
                        context._deleteTemplateAction(row, templateData.id);
                    }
            );
            confirmationRow.append(confirmBtn);
            var cancelBtn = $("<td class='cancelBtn'><div>" + messageResource.getMessage("userlist.userdata.permissions_templates.js.menu.delete_cancel") + "</div></td>");
            cancelBtn.on(
                    "click",
                    function()
                    {
                        context._switchRowToDeleteConfirmState(row, false);
                    }
            );
            confirmationRow.append(cancelBtn);
            rowInnerContent.append(deleteConfirmation);

            rowInnerContent.append("<td id='spinnerContainer' class='spinnerContainer'></td>");
        }
        else
        {
            delBtn.addClass("disabled");
        }

        row.append($("<table></table>").append(rowInnerContent));
        return row;
    }

    _appendInnerRowContent(rowInnerContent, templateData, isDefaultRow)
    {
        var context = this;
        var templateName = this._generateTemplateName(templateData, isDefaultRow);
        templateName.on(
                "click",
                function()
                {
                    if (context.isDisabledControls)
                    {
                        return;
                    }
                    context.hide();
                    context.onSelectTemplateCallback(templateData);
                }
        );

        rowInnerContent.append(templateName);

        var editBtn = $("<td class='editBtn'><div></div></td>");
        editBtn.on(
                'click',
                function()
                {
                    if (context.isDisabledControls)
                    {
                        return;
                    }
                    context.onEditTemplateCallback(templateData);
                }
        );
        rowInnerContent.append(editBtn);
    }

    _generateTemplateName(templateData, isDefaultRow)
    {
        return $("<td class='name'><div>" +
                 escapeHtmlSymbols(templateData.name) +
                 (isDefaultRow ? " " + messageResource.getMessage('userlist.userdata.permissions_templates.js.menu.row.default_template') : "") +
                 "</div></td>");
    }

    _resizeHandler = () => {
        this.hide();
    }

    _keyDownHandler = (event) => {
        if (this.isShow)
        {
            var activeRow = this._getActiveRow();
            switch (event.keyCode)
            {
                case KEY_CODE_ESC:
                    if (this._isRowInDeleteConfirmationState(activeRow))
                    {
                        activeRow.find("td.cancelBtn").click();
                    }
                    else
                    {
                        this.hide();
                    }
                    break;
                case KEY_CODE_ENTER:
                case KEY_CODE_SPACE:
                    if (this._isRowInDeleteConfirmationState(activeRow))
                    {
                        activeRow.find("td.confirmBtn").click(); // delete
                    }
                    else
                    {
                        activeRow.find("td.name").click(); // select
                    }
                    break;
                case KEY_CODE_DEL:
                    if (!this._isRowInDeleteConfirmationState(activeRow))
                    {
                        activeRow.find("td.delBtn").click();
                    }
                    break;
                case KEY_CODE_TAB:
                    this.hide();
                    break;
                case KEY_CODE_UP:
                    this._moveCursorToNextRow(true);
                    break;
                case KEY_CODE_DOWN:
                    this._moveCursorToNextRow(false);
                    break;
            }
            cancelBubble(event.originalEvent);
            return false;
        }
    }

    _mouseDownHandler = (event) => {
        if (this.isShow)
        {
            var target = event.target;
            while (target)
            {
                if (target == this.button[0])
                {
                    this.preventNextShowing = true;
                }
                if (target.id == this.menuId)
                {
                    cancelBubble(event);
                    return false;
                }
                target = target.parentElement;
            }
            cancelBubble(event);
            this.hide();
        }
    }

    showAt(element, button, offset)
    {
        if (this.preventNextShowing)
        {
            this.preventNextShowing = false;
            return;
        }
        if (this.canShowMenu) //Bug #54807
        {
            if (!this.canShowMenu())
            {
                return;
            }
        }
        this.isShow = true;
        this.button = button;

        this._removeKeydownHandler = KEY_HANDLERS.onKeyDown(this._keyDownHandler)
        var menuContainer = this.getMenuElement();
        this._renderContent(menuContainer, this.actualTemplatesData);
        element.append(menuContainer);

        menuContainer.show();
        var buttonOffset = button.offset();
        buttonOffset.top = buttonOffset.top + 30;
        if (offset)
        {
            buttonOffset.left += offset.left ? offset.left : 0;
            buttonOffset.top += offset.top ? offset.top : 0;
        }
        menuContainer.offset(buttonOffset);
        ScrollUtils.refreshCustomScroll(this.templatesListScroll);

        this._toggleListeners(true)
    }

    hide() {
        if (this.isShow) {
            if (this.deletingRpc) {
                this.deletingRpc.abort();
            }
            this.isShow = false;
            this.getMenuElement().hide();
            if (this._removeKeydownHandler)
                this._removeKeydownHandler()

            this._toggleListeners(false)
        }
    }

    _toggleListeners = (toggleOn) => {
        if (toggleOn) {
            $(document).on("mousedown.permissionsTemplatesMenu", this._mouseDownHandler)
            $(window).on("resize.permissionsTemplatesMenu", this._resizeHandler)
            $("body").on("keydown.permissionsTemplatesMenu", this._keyDownHandler)
        } else {
            $(document).off("mousedown.permissionsTemplatesMenu", this._mouseDownHandler)
            $(window).off("resize.permissionsTemplatesMenu", this._resizeHandler)
            $("body").off("keydown.permissionsTemplatesMenu", this._keyDownHandler)
        }
    }

    isShown()
    {
        return this.isShow;
    }

    _setActiveRow(row, byKey)
    {
        this._getActiveRow().removeClass("active").removeClass("byKey");
        row.addClass("active");
        if (byKey)
        {
            row.addClass("byKey")
        }
    }

    _getActiveRow()
    {
        return this.getMenuElement().find(".templateRow.active");
    }

    _getRowInDeleteConfirmationState()
    {
        return this.getMenuElement().find(".templateRow.deleteConfirmState");
    }

    _isRowInDeleteConfirmationState(row)
    {
        return row.hasClass("deleteConfirmState");
    }

    _switchRowToDeleteConfirmState(row, isDeletionState)
    {
        this._getRowInDeleteConfirmationState().removeClass("deleteConfirmState");
        row.toggleClass("deleteConfirmState", isDeletionState == true);
    }

    _moveCursorToNextRow(toTop)
    {
        var activeRow = this._getActiveRow();
        var selectNext = toTop ?
                         activeRow.prev(".templateRow") : activeRow.next(".templateRow");

        if (selectNext.length == 1)
        {
            this._setActiveRow(selectNext, true);

            var position = toTop ? ScrollUtils.POSITIONS.TOP : ScrollUtils.POSITIONS.BOTTOM;
            ScrollUtils.scrollIntoViewVertical(this.templatesListScroll, selectNext[0], position, true, 200);
        }
    }

    getMenuElement()
    {
        var menu = $.find("#" + this.menuId);
        if (menu.length == 0)
        {
            menu = $("<div id='" + this.menuId + "' class='permissionTemplatesMenu'></div>");
            this._afterMenuRendering(menu)
        }
        else
        {
            menu = $(menu[0]);
        }
        return menu;
    }

    _afterMenuRendering($menu) {
        $menu.click((e) => this.onClickDialogContent(e))
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/permissionsTemplates/PermissionsTemplatesMenu.js